import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import cx from 'classnames';
import { nameFirstLetterUpperCase, getFormInputClasses, setErrorWidth } from '../../utilities/form-helpers';

import FormInputCorrectMessage from './form-input-correct-message';
import FormInputErrorMessage from './form-input-error-message';
import FormInputLabel from './form-input-label';
import FormInputHelpMessage from './form-input-help-message';

class FormInputText extends Component {
  static defaultProps = {
    autoFocusInput: false,
    hasLabelTooltip: false,
    isClearable: false,
    isDisabled: false,
    isErrorUser: false,
    isHidden: false,
    isNameField: false,
    isRequired: false,
    passwordRegistrationModal: false,
    shouldSetErrorWidth: false,
    showIcon: false,
    type: 'text',
    validateNoSpecialCharsOnChange: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      errorWidth: null,
      onFocus: false,
      showPassword: false,
    };

    this.handleShowPassword = this.handleShowPassword.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.ffn = 0;
    this.ffc = 0;
    this.ktn = 0;
    this.redress = 0;
  }

  /* Component Lifecycle */
  componentWillMount() {
    const {
      input: { onBlur, value },
      meta: { touched },
    } = this.props;

    // If field has an initial value set, call onBlur so field
    // is 'touched', and validation state will be visible
    if (value && !touched) {
      onBlur();
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      input: {
        value,
      },
    } = this.props;

    const {
      input: {
        value: nextValue,
      },
      callbackIsCorrect,
      callbackIsNotCorrect,
      meta: {
        valid,
      },
    } = nextProps;

    const isValid = valid && nextValue && (nextValue !== value);
    if (isValid && callbackIsCorrect) { // Si es valido...
      callbackIsCorrect(nextValue);
    } else if (callbackIsNotCorrect && (nextValue !== value)) {
      callbackIsNotCorrect(nextValue);
    }
  }

  componentDidUpdate() {
    const { shouldSetErrorWidth } = this.props;
    const { errorWidth } = this.state;

    // Set error width (prevents error message being truncated)
    if (this.formInputErrorDOM && shouldSetErrorWidth) {
      const newErrorWidth = setErrorWidth(this.formInputErrorDOM.getBoundingClientRect().left);

      if (newErrorWidth !== errorWidth) {
        this.setState({
          errorWidth: newErrorWidth,
        });
      }
    }
  }

  /* Rendering */
  render() {
    const {
      autoFocusInput,
      className,
      errorMessageData,
      hasLabelTooltip,
      input: {
        name,
        onChange,
        value,
      },
      helpText,
      inputClassModifier,
      isClearable,
      isDisabled,
      isErrorUser,
      isHidden,
      isRequired,
      label,
      labelClassModifier,
      labelCopyID,
      maxLength,
      meta: {
        autofilled,
        error,
        touched,
        valid,
      },
      passwordRegistrationModal,
      placeholder,
      showIcon,
      showOptionalLabel,
      type,
      validateNoSpecialCharsOnChange,
    } = this.props;
    const { errorWidth } = this.state;

    let isError = error && touched;
    const isValid = valid && value && touched;

    if (validateNoSpecialCharsOnChange && !isError) {
      isError = error && error.includes('NO_SPECIAL');
    }

    let inputDescribedBy = null;

    if (isError) {
      inputDescribedBy = `${name}-error-text`;
    }

    if (hasLabelTooltip) {
      const errorText = inputDescribedBy ? `${inputDescribedBy} ` : '';
      inputDescribedBy = `${errorText}${name}-tooltip`;
    }

    const formFieldClasses = cx({
      'FormInput-wrapper': true,
      'is-disabled': isDisabled,
      'is-error': isError || isErrorUser,
      'is-correct': isValid,
    }, className);

    const isEmailField = name === 'email' || name === 'billingEmail';
    const { showPassword } = this.state;

    const classEyeView = cx({
      'iconShowPassword': true,
      'Icon Icon--eyeView icon-eye-view': !showPassword,
      'Icon Icon--eyePassword icon-eye-pass': showPassword,
      'isValid': isValid,
    });

    const classEyeViewEnrollment = cx('iconShowPassword Icon Icon--eyeView icon-eye-view', {
      'noShowPassword': !showPassword,
      'showPassword': showPassword,
      'icon-eye-view-valid': isValid,
    });

    const { onFocus } = this.state;

    const optionalClass = cx({
      'onFocus': onFocus && !isError && !isValid,
    });

    return (
      <div className={ getFormInputClasses(inputClassModifier, isHidden) } >
        <div className={ formFieldClasses } >
          <FormInputLabel
            isRequired={ isRequired }
            label={ label }
            labelClassModifier={ labelClassModifier }
            labelCopyID={ labelCopyID }
            name={ name }
            optionalClass={ optionalClass }
            showOptionalLabel={ showOptionalLabel } />
          <div className='wrapper-input-pass'>
            <div>
              <input
                aria-describedby={ inputDescribedBy }
                aria-disabled={ isDisabled }
                aria-invalid={ isError }
                autoCapitalize={ isEmailField ? 'off' : 'on' }
                autoComplete={ autofilled ? autofilled : 'off' }
                autoCorrect={ isEmailField ? 'off' : 'on' }
                autoFocus={ autoFocusInput }
                className='FormInput-input'
                disabled={ isDisabled }
                id={ name }
                maxLength={ maxLength }
                name={ name }
                onBlur={ (e) => this.handleBlur(e) }
                onChange={ onChange }
                onFocus={ this.handleFocus }
                placeholder={ placeholder }
                spellCheck={ !isEmailField }
                tabIndex={ isHidden || isDisabled ? -1 : 0 }
                type={ type !== 'password' ? type : !showPassword ? 'password' : 'text' }
                value={ value }
              />
              { showIcon && type === 'password' &&
                <span
                  className={ !passwordRegistrationModal ? classEyeView : classEyeViewEnrollment }
                  onClick={ this.handleShowPassword } />
              }
              { isClearable ? this.renderClearButton() : null }
              { ((type !== 'password' || passwordRegistrationModal) && isValid) &&
                  <FormInputCorrectMessage
                    isLoginModal={ true }
                    value={ value } />
              }
            </div>
            { (helpText && !isError) &&
              <FormInputHelpMessage
                copyID={ helpText }
                name={ name } />
            }
            { isError ?
              <FormInputErrorMessage
                error={ error }
                errorMessageData={ errorMessageData }
                errorWidth={ errorWidth }
                name={ name }
                ref={ (c) => this.formInputErrorDOM = ReactDOM.findDOMNode(c) }
              /> : null
            }
          </div>
        </div>
      </div>
    );
  }

  renderClearButton() {
    const {
      isDisabled,
      onClear,
    } = this.props;

    return !isDisabled &&
      <button
        className='FormInput-inputClearBtn Icon Icon--x'
        disabled={ isDisabled }
        onClick={ onClear } />;
  }

  /**
   * @param {SyntheticEvent} e
   */
  handleBlur(e) {
    const {
      input: {
        onBlur,
        value,
      },
      isNameField,
    } = this.props;

    const newValue = e ? e.target.value.trim() : value.trim();

    if (isNameField) {
      onBlur(nameFirstLetterUpperCase(newValue)) ;
    } else {
      onBlur(newValue);
    }
  }

  handleFocus() {
    const {
      input: {
        onFocus,
      },
    } = this.props;

    this.setState({
      onFocus: true,
    });

    onFocus();
  }

  handleShowPassword() {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  }
}

export default FormInputText;
